import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Store } from '@ngrx/store';
import { setExchangeInOrderToGenerate, setIsGenerateOrderExchange, setOrderToGenerateInExchange } from 'src/app/redux/actions/exchange.action';
import { goToInitForm, setIdentificatorFieldSelected, setIsClickedInConfirm } from 'src/app/redux/actions/options.action';
import { setHowSellValidation, setOrderToGenerate, setPurchaseMethodValidationState, setRucaAndSisa, setValidPxQ } from 'src/app/redux/actions/order.action';
import { areas } from '@shared-logic/user';
import { businessDict } from '@shared-logic/business-type';
import { appState } from 'src/app/shared/interfaces/appState.interface';
import { Order } from '@shared-logic/orders';
import { Price } from '@shared-logic/prices';
import { WayPay } from '@shared-logic/payments';
import { User } from '@shared-logic/user/user.interface';
import { OrderValidator, resetAllOrders } from 'src/app/shared/order';
import { OrderExchangeValidator } from 'src/app/shared/order-exchange';
import { getPriceBuyerCandidates, PriceValidator } from 'src/app/shared/price';
import { DialogOrderCreate } from '../dialogs/order-create/dialog';
import { Exchange, OrderExchange, isExchangeWayPayBlockingConfirm } from '@shared-logic/orders';
import { exchangeInitialState } from 'src/app/shared/const/exchange-orders';
import { getIsInvalidTown } from '../fields/place-of-origin/town/town.component';
import { Subscription } from 'rxjs';
import { HowSellValidation, /*PxQIBM,*/ ResponseHowSell, ResponseIBM, ResponseRucaAndSisa, RucaAndSisa, PurchaseMethodValidationResult, PURCHASE_METHOD_RESPONSE, PurchaseMethodDefaultClassification } from '@shared-logic/integration-ibm';
import { wayPayNames } from '@shared-logic/payments';
import { isAnyInvalidBuyer } from '../fields/buyer-order/only-sell/only-sell.component';
import { SessionChecker } from 'src/app/shared/session.checker';
import { getIsWayPayDeferred, getWayPayCodeIBM } from '@shared-logic/payments';
import { isIndicatorsIncomplete } from 'src/app/shared/to-fix';
import { isInvalidStartDate } from '@shared-logic/utils';
import { itCanBeHowSell, COMMODITIES_CODE } from '@shared-logic/subjects';
import { howSellValidationInitialState, rucaAndSisaInitialState, purchaseMethodValidationInitialState, orderTags } from 'src/app/shared/const/orders';
import { PURCHASE_METHOD_GATE_PENDING } from 'src/app/shared/interfaces/order.interface';
import { WAY_PAY_VOID } from '@shared-logic/payments';
import { isProduction } from 'src/app/shared/const/options';
import { resolvePurchaseMethodDefault, mapBuyerPurchaseMethodDefault, PurchaseMethodGateStatus } from '@shared-logic/purchase-method';
import { CREATION_TYPE_CONST } from '@shared-logic/prices';
import { isCramdownApplicable, isCramdownProductMismatch, resolveCreationType } from '@shared-logic/subjects/buyers-validations';
import { priceTags } from 'src/app/shared/const/prices.const';

interface HowSellState {
  codeS: number;
  howSell: number;
  broker: number;
}

interface PurchaseMethodState {
  buyerCode: number;
  purchaseMethod: number;
}

@Component({
  template: ''
})
export class FormComponent implements OnInit, OnDestroy {
  @ViewChild("formulario") formulario!: ElementRef;
  @Output() applyButtonEvent = new EventEmitter<boolean>();
  public numOfStep: number = 1;
  order!: any;
  onlyExchange!: OrderExchange;
  price!: Price;
  identificatorFieldSelected: number = -1;
  isClickedInConfirm: boolean = false;
  public user!: User;
  public isOperator: boolean = false;
  public isComercial: boolean = false;
  public showPartQuality: boolean = false;
  disabledButton: boolean = false;

  public showExchangeOptions: boolean = false;

  //---------- Way pay default ----------\\
  public wayPayDefault: WayPay = WAY_PAY_VOID;
  public agreedDiscountDefault: number = 0;

  isGenerateToFix: boolean = false;

  //---------- Validation Exchanger ----------\\
  public isExchangeOrder: boolean = false;

  //---------- Validation HowSell ----------\\
  public howSellValidation!: HowSellValidation;
  public rucaAndSisa!: RucaAndSisa;
  private lastStateHowSell: HowSellState | null = null;
  //public processHowSell:boolean=false;
  /* Mismo patrón que purchaseMethodValidateRequestId (R4/L5): con el guard de
  inProcessRucaAndSisa retirado de validateHowSell, VALCATE/VALIRUSI de tripticos
  sucesivos pueden quedar en vuelo a la vez, y una respuesta vieja que llega tarde
  no debe pisar el veredicto de la petición más reciente. */
  private howSellValidateRequestId = 0;
  public inProcessRucaAndSisa: boolean = false;
  public isInvalidRucaAndSisa: boolean = false;
  public completed: boolean = false;
  public isInvalid: boolean = false;
  public failedConnection: boolean = false;
  public inProcessInvalid: boolean = false;

  //---------- Validation PurchaseMethod ----------\\
  /* Single state instead of three independent booleans (ADR-0001/ADR-0002, R4): null
  means nothing to report (idle, or a value not yet checked). */
  public purchaseMethodStatus: PurchaseMethodGateStatus | null = null;
  public purchaseMethodMessageError: string | null = null;
  public purchaseMethodIsVisible: boolean = false;
  public purchaseMethodIsEditable: boolean = true;
  public purchaseMethodIsFasonContract: boolean = false;
  private lastStatePurchaseMethod: PurchaseMethodState | null = null;
  private purchaseMethodValidateRequestId = 0;
  /* Tracks the impliedBuyer (resolveImpliedBuyerFromOnlySell) that last triggered or
  cleared a COMODEF query, so repeated order$ emissions for unrelated field changes
  don't re-fire it. 0 is "not yet evaluated"; -1 is "no single implied buyer" -- both
  are distinct from any real buyerCode (R1/R2/R4). */
  private lastStatePurchaseMethodDefault: number = 0;
  private purchaseMethodDefaultRequestId = 0;


  //---------- Validation PxQ ----------\\
  /*public messagePxQ:string='';
  private lastStatePxQ:PxQIBM | null=null;
  private validPxQ!:string;*/

  //Subscriptions
  private vExchanger$!: Subscription;
  private vHowSell$!: Subscription;
  //private vPxQ$!:Subscription;
  private vRucaAndSisa$!: Subscription;
  private price$!: Subscription;
  private order$!: Subscription;
  private exchange$!: Subscription;
  private options$!: Subscription;
  private user$!: Subscription;
  private isGenerateToFix$!: Subscription;

  constructor(public store: Store<appState>, public checker: SessionChecker,
    public orderExcV: OrderExchangeValidator, public orderV: OrderValidator, public priceV: PriceValidator, public dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.store.dispatch(setIdentificatorFieldSelected({ identificator: -1 }));

    this.price$ = this.store.select('price').subscribe(price => {
      this.price = price.generatePrice;
    })

    this.vExchanger$ = this.store.select('order', 'validation', 'isExchanger').subscribe(isExchanger => {
      this.isExchangeOrder = isExchanger;
    });

    this.vHowSell$ = this.store.select('order', 'howSellValidation').subscribe(howSellValidation => {
      this.howSellValidation = howSellValidation;
      this.refreshDisabledOrder();
    });

    /*this.vPxQ$=this.store.select('order','validPxQ').subscribe(validPxQ=>{
      this.validPxQ=validPxQ;
      this.refreshDisabledOrder();
    });*/

    this.vRucaAndSisa$ = this.store.select('order', 'rucaAndSisa').subscribe(rucaAndSisa => {
      this.rucaAndSisa = rucaAndSisa;
      this.refreshDisabledOrder();
    });

    this.order$ = this.store.select('order', 'generateOrder').subscribe(order => {
      this.order = order;
      /* FormValidationComponent overrides purchaseMethodFollowsCreationOrder() to
      false: it drives the same fields from order.edit.ordersEdit[indexToEdit] instead
      (R10), and letting both subscriptions write them would leak a stale creation-order
      verdict into the editing screen (finding 02) or vice versa. */
      if (this.purchaseMethodFollowsCreationOrder()) {
        const impliedBuyer = this.resolveImpliedBuyerFromOnlySell(order);
        this.resolvePurchaseMethodForCreation(order, impliedBuyer);
      }
      this.refreshDisabledOrder();
      this.functionsWithFormOrders(order);
      //this.validateTons(this.order);
      this.validateHowSell(this.order);
      if (this.purchaseMethodFollowsCreationOrder()) {
        this.validatePurchaseMethod(this.order);
      }
    })

    this.exchange$ = this.store.select('exchange').subscribe(exchange => {
      this.showExchangeOptions = exchange.isGenerateOrderExchange;
      this.onlyExchange = exchange.generateOrder;
    })

    this.user$ = this.store.select('usuario').subscribe(user => {
      this.user = user;
      this.isComercial = user.area == areas.comercial;
      this.isOperator = user.area == areas.commodities;
    })

    this.isGenerateToFix$ = this.store.select('options', 'isGenerateToFix').subscribe(toFix => {
      this.isGenerateToFix = toFix;
    })

    this.options$ = this.store.select('options').subscribe(options => {
      this.identificatorFieldSelected = options.identificatorFieldSelectedInForm;
      if (options.goToInitForm) {
        this.goToInitForm();
      }
    });

  }

  ngOnDestroy(): void {
    this.store.dispatch(setIsClickedInConfirm({ isClickedInConfirm: false }));
    //Si el tamaño de la pantalla es de más de 950. Se resetean los valores de los campos de la orden
    if (window.innerWidth > 950) {
      resetAllOrders(this.store);
    }
    this.unsubscribe();
  }

  unsubscribe() {
    this.vExchanger$?.unsubscribe();
    this.vHowSell$?.unsubscribe();
    //this.vPxQ$?.unsubscribe();
    this.vRucaAndSisa$?.unsubscribe();

    this.price$?.unsubscribe();
    this.order$?.unsubscribe();
    this.exchange$?.unsubscribe();
    this.options$?.unsubscribe();
    this.user$?.unsubscribe();
    this.isGenerateToFix$?.unsubscribe();
  }

  isDevelopment(): boolean {
    return !isProduction();
  }

  refreshDisabledOrder() { }

  loadUser() {
    this.checker.rememberAndActualizateUser(this.store)
  }

  changeStep(numOfStep: number, formulario: any) {
    this.numOfStep = numOfStep;
    this.goToTop(formulario);
  }

  /* go to the top of the form */
  goToTop(formulario: any) {
    if (formulario) {
      formulario.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  goToInitForm() {
    this.changeStep(1, this.formulario.nativeElement);
    this.store.dispatch(goToInitForm({ goToInitForm: false }));
  }

  getNumMaxOfStep() {
    if (this.isGenerateToFix && this.showExchangeOptions) {
      return 5;
    } else if (this.isGenerateToFix || this.showExchangeOptions) {
      return 4;
    }
    return 3;
  }


  confirmOrder(formulario: any) {
    if (this.isDisabledOrder(this.showExchangeOptions)) {
      this.store.dispatch(setIsClickedInConfirm({ isClickedInConfirm: true }));
      this.verifyElement(formulario);
    } else {
      if (this.isComercial || this.isOperator) {
        this.dialog.open(DialogOrderCreate);
      } else {
        this.loadUser();
      }
    }
  }

  isDisabledOrder(isExchange: boolean = false) {
    try {
      const commonChecks = !this.isCodePostalValid(this.order) || !this.isWayPayValid(this.order.price) ||
        isInvalidStartDate(this.order.price.deliveryPeriod.startDate) || this.invalidBuyer(this.order) ||
        this.isCramdownOrderBlocked(this.order);
      const purchaseMethodBlocked = this.isKnownBuyerPurchaseMethodBlocked();

      return isExchange ? this.orderV.isOrderIncomplete(this.order) || this.orderExcV.isPriceExchangeInvalid(this.onlyExchange.exchange) ||
        isExchangeWayPayBlockingConfirm(this.order, this.onlyExchange.exchange) ||
        commonChecks || purchaseMethodBlocked : //|| this.validPxQ?.toLowerCase()!='ok' :
        this.orderV.isOrderIncompleteWithHowSellValidation(this.order, this.howSellValidation, this.rucaAndSisa, /* this.validPxQ */) || commonChecks || purchaseMethodBlocked;
    } catch (err) { }
    return true;
  }

  deleteStep(numOfStep: number) { }

  deleteAll(numOfStep: number) { }

  verifyElement(formulario: any) {
    if (
      this.order.sellerData.codeS == -1 ||
      this.order.placeOfOrigin.province == -1 || this.order.placeOfOrigin.town == -1 || this.order.placeOfOrigin.afip == -1 ||
      this.order.broke == -1 ||
      this.invalidBuyer(this.order) ||
      this.order.howSell == -1 ||
      this.order.tons == -1 ||
      this.isCramdownOrderBlocked(this.order)) {
      this.changeStep(1, formulario);
    } else if (
      this.order.price.typeBusiness == -1 ||
      this.order.price.productName == -1 ||
      (this.isGenerateToFix ? false : this.order.price.price == -1 || this.order.price.typeCoin == '--') ||
      this.order.price.placeOfDelivery.zone == -1 ||
      this.requirePort() ||
      this.order.price.deliveryPeriod.endDate == '--' ||
      this.order.price.deliveryPeriod.startDate == '--' ||
      isInvalidStartDate(this.order.price.deliveryPeriod.startDate)
    ) {
      this.changeStep(2, formulario);
    } else if (
      this.order.price.quality == -1 ||
      this.order.price.harvest == '--'
    ) {
      this.changeStep(3, formulario);
    } else if (
      (this.order.price.indicators?.length > 0 ? isIndicatorsIncomplete(this.order.price?.indicators, this.order.price?.conditionType) : false)
    ) {
      this.changeStep(4, formulario);
    }
  }

  showQualities(event: string) {
    if (event == 'add') {
      this.showPartQuality = true;
    }
  }

  setExchangeOptions(boolean: boolean) {
    if (boolean) {
      this.store.dispatch(setOrderToGenerateInExchange({ order: this.order })); //Seteamos la orden
      let newExchange: Exchange = JSON.parse(JSON.stringify(exchangeInitialState)); //Creamos una contrapartida vacía
      newExchange = this.orderExcV.getExchangeInitial(this.order); //Obtenemos los datos por default de la contrapartida vacía.
      this.setPreviusWayPayAndAgreedDiscount(this.order, newExchange); //Seteamos el tipo de pago y descuento convenido que se asignó por default
      this.store.dispatch(setExchangeInOrderToGenerate({ exchange: newExchange })); //Seteamos la contrapartida en el store

    } else {
      let exchangeWitoutExchange = JSON.parse(JSON.stringify(this.order));
      delete exchangeWitoutExchange.exchange;
      this.store.dispatch(setOrderToGenerate({ order: exchangeWitoutExchange }));
    }
    this.store.dispatch(setIsGenerateOrderExchange({ isGenerateOrderExchange: boolean }));
    setTimeout(() => {
      this.changeStep(this.getNumMaxOfStep(), this.formulario.nativeElement);
    }, 10)
  }

  setPreviusWayPayAndAgreedDiscount(contractMother: Order, exchange: Exchange) {
    this.wayPayDefault = exchange.wayPay;
    this.agreedDiscountDefault = exchange.agreedDiscount;
  }

  /*isNideraOSemillas(){
    const codeS=this.order.sellerData.codeS;
    const subSyng=this.order.price.businessParticularities.subdivisionSyngenta;
    return this.orderV.isSyngentaNidera(codeS, subSyng) || this.orderV.isSyngentaSemillas(codeS, subSyng);
  }*/

  requirePort() {
    return this.priceV.isInvalidOptionalPort(this.order.price.placeOfDelivery);
  }

  isConDescarga(order: Order) {
    return order.price.typeBusiness == businessDict.conDescarga;
  }

  isContraEntrega(wayPay: WayPay | undefined) {
    return wayPay?.wayPayName == wayPayNames.contraEntrega;
  }

  isWayPayInvalidToExpiration(wayPay: WayPay | undefined) {
    return this.isContraEntrega(wayPay) || getIsWayPayDeferred(wayPay?.wayPayName ?? 0);
  }

  isInDolars(order: Order) {
    return this.orderV.isInDolars(order);
  }

  getFieldType() { }

  // Preview de la Marca dentro del formulario de condición. Acepta los compradores seleccionados
  // (price.arrayOfBuyers) porque en el alta el comprador todavía no está fijado en
  // price.observations.buyer: recién se fija por comprador dentro de PriceValidator.confirmPrice,
  // que es el único punto que resuelve la Marca definitiva de cada condición generada. Con más de
  // un comprador seleccionado no existe una Marca única posible, así que el preview queda neutro.
  protected normalizePriceCramdown(price: Price, buyerCandidates: number[] = []): Price {
    const candidates = getPriceBuyerCandidates(price, buyerCandidates);
    const buyerCode = candidates.length === 1 ? candidates[0] : 0;
    const productName = Number(price?.productName ?? 0);
    const creationType = resolveCreationType(0, buyerCode, productName);

    if (price.creationType === creationType) {
      return price;
    }

    return { ...price, creationType };
  }

  protected normalizeOrderCramdown(order: Order): Order {
    const sellerCode = Number(order?.sellerData?.codeS ?? 0);
    const buyerCode = Number(order?.price?.observations?.buyer ?? 0);
    const productName = Number(order?.price?.productName ?? 0);
    const creationType = isCramdownApplicable(sellerCode, buyerCode, productName)
      ? CREATION_TYPE_CONST.CRAMDOWN
      : CREATION_TYPE_CONST.STANDARD;

    if (order.price.creationType === creationType) {
      return order;
    }

    return {
      ...order,
      price: { ...order.price, creationType },
    };
  }

  isCodePostalValid(order: Order) {
    return !getIsInvalidTown(order.placeOfOrigin)
  }

  isWayPayValid(price: Price) {
    return this.priceV.getWayPayIBM(price) != 0;
  }

  invalidBuyer(order: Order) {
    return isAnyInvalidBuyer(order.buyer.onlySell, order);
  }

  // Bloqueo duro (R2, aditivo -- no reemplaza normalizeOrderCramdown/normalizePriceCramdown,
  // que solo deciden la Marca). true cuando Vendedor o algún candidato de "Solo le vende a" es
  // Cramdown-elegible y el producto de la orden no es Soja. Único punto que evalúa la orden
  // completa; seller-name.component.ts y only-sell.component.ts calculan el mismo resultado por
  // campo, solo para mostrar la leyenda en el lugar correcto (Decisión 1 del plan madurado).
  isCramdownOrderBlocked(order: Order): boolean {
    const sellerCode = Number(order?.sellerData?.codeS ?? 0);
    const onlySellValue = order?.buyer?.onlySell;
    const buyerCandidates: number[] = Array.isArray(onlySellValue)
      ? onlySellValue.map((value: any) => Number(value))
      : (onlySellValue ? [Number(onlySellValue)] : []);
    const productName = Number(order?.price?.productName ?? 0);
    return isCramdownProductMismatch(sellerCode, buyerCandidates, productName);
  }

  focusField(position: any, formulario: any) {
    //Scrolleamos en el formulario hasta la posicion que se le pasa
    formulario.scrollTo({ top: position, behavior: 'smooth' });
  }

  applyButtonEmit(bool: boolean) {
    this.applyButtonEvent.emit(bool);
  }

  /*his function is used so that in the order form component, 
  a variable is set to true or false if the business is from Syngenta Agro AVC
  and if the business have 'valid until'*/
  functionsWithFormOrders(order: Order) { }

  /**
   * Since at IBM there is a problem with the number of digits, a function was 
   * momentarily created that, passing certain data, tells you if that business 
   * would generate problems in the future.
   * @param order    
   * @returns 
   * */
  /*private validateTons(order:Order){
    let PxQ:PxQIBM | null=null;
    if(order.price){
      PxQ={
        CEREAL: order.price.productName,
        MONEDA: order.price.typeCoin == typeCoins.ARS ? 1 : order.price.typeCoin==typeCoins.USD ? 4 : 0,
        PRECIO: this.isGenerateToFix || order.price.price<=0? 0: order.price.price,
        TONELA: order.tons,
        IMPBON: getImporteBonification(order?.price?.businessParticularities),
        MONBON: getTypeCoinBonificationIBM(order?.price?.businessParticularities),
        PORBON: 0,
      }
    }

    if(PxQ && this.isValidPxQ(PxQ, this.isGenerateToFix) && !this.isEqualsPxQ(PxQ, this.lastStatePxQ)){
      this.messagePxQ='Validando toneladas...';
      this.lastStatePxQ=PxQ;

      console.log("Validando toneladas");

      this.orderV.getValidatePxQ(PxQ).then((res:ResponseIBM)=>{
        this.store.dispatch(setValidPxQ({validPxQ: res.status.status}));
        if(res.status.status!='ok'){
          this.messagePxQ=res.status.messageError.msg;
        } else {
          this.messagePxQ=''
        }
      })

    }
  }

  isValidPxQ(PxQ:PxQIBM | null, isToFix:boolean):boolean{
    if(PxQ){
      return ( (isToFix && PxQ.PRECIO<=0) || (!isToFix && PxQ.PRECIO>0) ) && 
      PxQ.TONELA>0 && PxQ.CEREAL>0 && 
      ((PxQ.MONEDA==1 && PxQ.PRECIO>1000) || (PxQ.MONEDA==4 && PxQ.PRECIO<1000) || (PxQ.MONEDA==0 && PxQ.PRECIO==0)) 
    }
    return false;
  }

  isEqualsPxQ(PxQ:PxQIBM | null, lastState:PxQIBM | null):boolean{
    if(PxQ && lastState){
      return PxQ.CEREAL==lastState.CEREAL && 
      PxQ.MONEDA==lastState.MONEDA && 
      PxQ.PRECIO==lastState.PRECIO && 
      PxQ.TONELA==lastState.TONELA && 
      PxQ.IMPBON==lastState.IMPBON &&
      PxQ.MONBON==lastState.MONBON &&
      PxQ.PORBON==lastState.PORBON;
    }
    return false;
  }*/

  private validateHowSell(order: Order) {
    //const howSell=getHowSellIBM(order.howSell); //Obtenemos el valor de cómo vende de IBM
    const newState: HowSellState = {
      codeS: order.sellerData.codeS,
      howSell: order.howSell,
      broker: order.broke
    }

    this.isInvalid = false; //Reiniciamos los valores de cómo vende
    this.isInvalidRucaAndSisa = false; //Reiniciamos los valores de cómo vende

    /* Un cambio en cualquiera de los tres valores del tríptico (vendedor, cómo vende,
    corredora) caduca el veredicto guardado en el mismo tick del cambio, antes de que
    se dispare -o no- una nueva consulta. Así el gate (isOrderIncompleteWithHowSellValidation)
    nunca lee un veredicto que ya no corresponde al tríptico vigente, ni siquiera
    mientras la nueva respuesta de IBM está en camino (R1, R2). */
    if (!this.isEqualsHowSell(newState, this.lastStateHowSell) /*&& !this.isExchangeOrder*/) {
      this.store.dispatch(setHowSellValidation({ howSellValidation: howSellValidationInitialState }));
      this.store.dispatch(setRucaAndSisa({ rucaAndSisa: rucaAndSisaInitialState }));

      this.lastStateHowSell = newState;

      /* Un tríptico incompleto se queda con el reset de arriba y no dispara ninguna
      consulta: no hay nada que IBM pueda validar todavía (R5). Ya no se condiciona a
      inProcessRucaAndSisa: un cambio que llega mientras el RUCA/SISA anterior sigue
      en vuelo debe disparar su propia consulta, no quedar descartado (R3). El
      contador de petición en verifyHowSell/verifyRucaAndSisa es lo que ahora decide
      qué respuesta prevalece (R4). */
      if (this.isValidState(newState)) {
        this.verifyHowSell(newState);
      }
    }
  }

  verifyRucaAndSisa(state: HowSellState, requestId: number) {
    this.inProcessRucaAndSisa = true;

    this.orderV.getValidateRucaAndSisa(state.codeS, state.howSell).then((res: ResponseRucaAndSisa) => {
      /* Un triptico más nuevo ya disparó su propia consulta (R4/L5): esta respuesta
      quedó superada, no debe pisar el veredicto vigente. */
      if (requestId !== this.howSellValidateRequestId) {
        return;
      }
      console.log(res);
      this.store.dispatch(setRucaAndSisa({ rucaAndSisa: res.data.msg }));
      this.isInvalidRucaAndSisa = !itCanBeHowSell(state.howSell, res.data.msg, state.codeS);
      this.inProcessRucaAndSisa = false; //No se procesa Ruca y Sisa
    }).catch(() => {
      /* Without this branch a rejected lookup left "Verificando Ruca y Sisa..." on
      screen forever and kept the guard that reads inProcessRucaAndSisa closed. The
      slice is reset to its initial value, which itCanBeHowSell rejects, so the order
      stays blocked instead of passing as validated. isInvalidRucaAndSisa is left
      untouched on purpose: its message would blame the seller's data for an outage. */
      if (requestId !== this.howSellValidateRequestId) {
        return;
      }
      this.store.dispatch(setRucaAndSisa({ rucaAndSisa: rucaAndSisaInitialState }));
      this.inProcessRucaAndSisa = false;
    });
  }

  verifyHowSell(state: HowSellState) {
    this.inProcessInvalid = true;
    /* Con el guard de inProcessRucaAndSisa retirado de validateHowSell, más de una
    consulta puede quedar en vuelo a la vez; el contador decide cuál respuesta
    prevalece (R3, R4/L5, mismo patrón que purchaseMethodValidateRequestId). */
    const requestId = ++this.howSellValidateRequestId;

    this.orderV.getValidateHowSell(state.codeS, state.howSell, state.broker).then((res: ResponseHowSell) => {
      if (requestId !== this.howSellValidateRequestId) {
        return;
      }
      console.log(res);
      if (res.status.status == 'ok') {
        this.store.dispatch(setHowSellValidation({ howSellValidation: res.data.msg }));
        this.isInvalid = false; //No es una forma de venta inválida
        this.verifyRucaAndSisa(state, requestId);
      } else {
        this.isInvalid = true;
        this.store.dispatch(setHowSellValidation({ howSellValidation: howSellValidationInitialState }));
        this.inProcessRucaAndSisa = false;
      }

      this.completed = true;
      this.inProcessInvalid = false;
      this.failedConnection = false;

    }).catch(err => {
      if (requestId !== this.howSellValidateRequestId) {
        return;
      }
      this.store.dispatch(setHowSellValidation({ howSellValidation: howSellValidationInitialState }));
      this.completed = true;
      this.isInvalid = true;
      this.failedConnection = true;

      this.inProcessInvalid = false;
    });
  }

  private isValidState(state: HowSellState): boolean {
    return state?.codeS > 0 && state?.howSell > 0 && state?.broker > 0;
  }

  /*private isValidHowSell(codeIBM:string):boolean{
    //Si no está completo el como vende
    //O si en el ruca y sisa no tiene producción propia
    //O si no tiene el vendedor
    //O si no tiene el vendedor del ruca y sisa
    //Y estamos en el campo de orden y el proceso no corrió, entonces lo ejecutamos
    return true
    return (codeIBM != this.howSellValidation.ComoVende || codeIBM!=this.rucaAndSisa['Producción Propia'] 
    || !this.howSellValidation.Vendedor || !this.rucaAndSisa.Vendedor) 
    /*&& (howSell?.codeS ?? 0)>0 && (howSell?.howSell ?? 0)>0;
    /*&& (this.fieldIdentificator==fieldType.ORDER)
  }*/

  private isEqualsHowSell(state: HowSellState | null, lastState: HowSellState | null): boolean {
    if (state && lastState) {
      return state.codeS == lastState.codeS && state.howSell == lastState.howSell && state.broker == lastState.broker;
    }
    return false;
  }

  private validatePurchaseMethod(order: Order) {
    if (!order.purchaseMethod || order.purchaseMethod <= 0 || !order.price?.observations?.buyer || order.price.observations.buyer <= 0) {
      return;
    }

    const newState: PurchaseMethodState = {
      buyerCode: order.price.observations.buyer,
      purchaseMethod: order.purchaseMethod,
    };

    if (this.isEqualsPurchaseMethod(newState, this.lastStatePurchaseMethod)) {
      return;
    }

    this.lastStatePurchaseMethod = newState;
    this.verifyPurchaseMethod(newState);
  }

  /* Shared by the creation flow (validatePurchaseMethod above) and, from T2.5, by
  FormValidationComponent's own order.edit-driven resolution: both need the exact same
  pending-then-classified dispatch, so form-validation reuses this instead of a second
  copy. */
  verifyPurchaseMethod(state: PurchaseMethodState) {
    const pair = { buyerCode: state.buyerCode, purchaseMethod: state.purchaseMethod };
    /* Guards a stale response: with FormValidationComponent now able to fire this once
    per order the operator switches to, an older call resolving after a newer one must
    not overwrite it (R5, same pattern as add-buyer's requestId guards). */
    const requestId = ++this.purchaseMethodValidateRequestId;

    this.purchaseMethodStatus = PURCHASE_METHOD_GATE_PENDING;
    this.purchaseMethodMessageError = null;
    /* The pair travels with the verdict from the very first dispatch, so a result that
    arrives after the operator changed buyer or purchase method can be recognised as
    belonging to a combination that is no longer on screen. */
    this.store.dispatch(setPurchaseMethodValidationState({
      purchaseMethodValidation: { pair, status: PURCHASE_METHOD_GATE_PENDING }
    }));

    /* The service classifies the answer, so an outage no longer arrives as a rejection.
    isDisabledOrder already blocks on any non-valid, non-idle status, so nothing
    observable changes here beyond what T2.1 already changed. */
    this.orderV.getValidatePurchaseMethod(state.buyerCode, state.purchaseMethod).then((result: PurchaseMethodValidationResult) => {
      if (requestId !== this.purchaseMethodValidateRequestId) {
        return;
      }
      this.purchaseMethodStatus = result.status;
      this.purchaseMethodMessageError = result.messageError;
      this.store.dispatch(setPurchaseMethodValidationState({
        purchaseMethodValidation: { pair, status: result.status }
      }));
    });
  }

  private isKnownBuyerPurchaseMethodBlocked(): boolean {
    /* A field that is visible (per the OnlySell/Fasón rule in resolvePurchaseMethodForCreation)
    but still empty only blocks on its own outside the creation flow (Add-Buyer/form-validation,
    via the inherited purchaseMethodFollowsCreationOrder() === false branch below): without this,
    an operator who never touches the field there leaves purchaseMethodStatus at its initial null
    (validatePurchaseMethod only fires once purchaseMethod > 0), and the check below -- which only
    reads a tracked status -- never sees a reason to block. Same missing-field guard add-buyer
    already has (missingPurchaseMethod). In the creation flow itself, an empty value no longer
    blocks: the operator can advance without deciding "Cómo compra" yet, and Add-Buyer/
    form-validation still enforce it independently before confirming (R6-style boundary). A
    present-but-invalid/rejected/unavailable value still blocks everywhere via the second
    return below -- this exemption is for "not decided yet", not for a known-bad combination. */
    if (this.purchaseMethodIsVisible && !(this.order?.purchaseMethod > 0)) {
      return !this.purchaseMethodFollowsCreationOrder();
    }

    return this.order?.price?.observations?.buyer > 0 &&
      this.purchaseMethodStatus !== null && this.purchaseMethodStatus !== PURCHASE_METHOD_RESPONSE.VALID;
  }

  /* True for the creation forms (form-order, form-order-from-board): they drive
  purchase-method resolution/validation from this class's own order.generateOrder
  subscription above. FormValidationComponent overrides this to false. */
  protected purchaseMethodFollowsCreationOrder(): boolean {
    return true;
  }

  private resolvePurchaseMethodForCreation(order: Order, impliedBuyer: number): void {
    const isFasonContract = order.price.businessParticularities?.isFasonContract === true;
    const onlySellValue = order.buyer?.onlySell;
    const onlySell = Array.isArray(onlySellValue) ? Number(onlySellValue[0]) : Number(onlySellValue);
    const resolution = resolvePurchaseMethodDefault({
      isFasonContract,
      onlySell: Number.isNaN(onlySell) ? 0 : onlySell,
      hasBuyerDefault: false,
    });

    this.purchaseMethodIsVisible = resolution.isVisible;
    this.purchaseMethodIsEditable = resolution.isEditable;
    this.purchaseMethodIsFasonContract = isFasonContract;

    if (isFasonContract) {
      if (order.purchaseMethod !== resolution.value) {
        this.store.dispatch(setOrderToGenerate({
          order: { ...order, purchaseMethod: resolution.value },
        }));
      }
      return;
    }

    /* R1/R4: COMODEF only fires when "Solo le vende a" resolves to exactly one
    unambiguous buyer (impliedBuyer, computed by resolveImpliedBuyerFromOnlySell the
    same way as its price.observations.buyer inference -- not the raw onlySell[0]
    above, which does not distinguish "one buyer" from "first of several"). Once
    COMODEF resolves, queryDefaultPurchaseMethodForCreation writes the default into
    order.purchaseMethod; the next order$ emission then runs validatePurchaseMethod
    exactly as it already does for a manually-typed value, so VALCOMO is not
    duplicated here (R3). lastStatePurchaseMethodDefault makes this idempotent across
    unrelated order$ emissions, and R2/R8 clear purchaseMethod unconditionally the
    moment impliedBuyer leaves that single-buyer state, before any pending COMODEF
    response can be applied (guarded in queryDefaultPurchaseMethodForCreation below). */
    if (impliedBuyer !== this.lastStatePurchaseMethodDefault) {
      this.lastStatePurchaseMethodDefault = impliedBuyer;

      if (impliedBuyer > 0) {
        this.queryDefaultPurchaseMethodForCreation(impliedBuyer);
      } else {
        this.resetPurchaseMethodForAmbiguousOrEmptyBuyer(order);
      }
    }
  }

  /* R2/R8: the moment onlySell leaves the exactly-one-buyer state, purchase method and its
  verdict are cleared in this same tick, unconditionally -- regardless of whether the current
  value was autocompleted or typed manually, mirroring validateHowSell's same-tick reset
  (lines ~535-537). Resetting lastStatePurchaseMethod to null, not just order.purchaseMethod
  to 0, matters: without it, isEqualsPurchaseMethod could later treat a re-resolved
  {buyerCode, purchaseMethod} pair identical to the one seen before this reset as
  "unchanged" and skip re-validating, leaving the just-reset idle verdict stuck on screen
  even though a fresh COMODEF/VALCOMO cycle already ran. */
  private resetPurchaseMethodForAmbiguousOrEmptyBuyer(order: Order): void {
    this.lastStatePurchaseMethod = null;
    this.purchaseMethodStatus = null;
    this.purchaseMethodMessageError = null;

    this.store.dispatch(setPurchaseMethodValidationState({
      purchaseMethodValidation: purchaseMethodValidationInitialState,
    }));

    if (order.purchaseMethod > 0) {
      this.store.dispatch(setOrderToGenerate({
        order: { ...order, purchaseMethod: 0 },
      }));
    }
  }

  /* Mirrors add-buyer.component.ts's queryDefaultPurchaseMethod (same COMODEF call,
  same requestId-guard shape guarding a stale response from a superseded buyer
  selection, R5) but writes the result into order.purchaseMethod via setOrderToGenerate
  instead of a local field, so the existing validatePurchaseMethod/verifyPurchaseMethod
  pair picks it up on the next order$ emission instead of a second VALCOMO call site.
  requestId alone is not enough (S3): if the buyer set becomes ambiguous (2+) while this
  call is in flight, resolvePurchaseMethodForCreation does not issue a new COMODEF call
  (impliedBuyer <= 0), so the counter never advances -- but the response must still be
  discarded. Comparing buyerCode against the live lastStatePurchaseMethodDefault catches
  that case too, since it is updated on every impliedBuyer transition, not only on a new
  COMODEF call. */
  private queryDefaultPurchaseMethodForCreation(buyerCode: number): void {
    const requestId = ++this.purchaseMethodDefaultRequestId;

    this.orderV.getDefaultPurchaseMethod(buyerCode).then((classification: PurchaseMethodDefaultClassification) => {
      if (requestId !== this.purchaseMethodDefaultRequestId || buyerCode !== this.lastStatePurchaseMethodDefault) {
        return;
      }

      /* getDefaultPurchaseMethod never rejects (order.service.ts's settleIbmCall turns a
      transport failure into a classified {status: UNAVAILABLE} result), so this is the
      only place a COMODEF outage surfaces. Mirrors add-buyer.component.ts's own
      queryDefaultPurchaseMethod: an unreachable lookup is a degraded dependency, not a
      rejected purchase method (S7) -- it must show the same 'unavailable' state the
      field already uses for VALCOMO failures, not fail silently. */
      if (classification.status === PURCHASE_METHOD_RESPONSE.UNAVAILABLE) {
        this.purchaseMethodStatus = PURCHASE_METHOD_RESPONSE.UNAVAILABLE;
        return;
      }

      const defaultValue = mapBuyerPurchaseMethodDefault(classification.rawValue ?? '');
      if (!defaultValue.hasDefault || defaultValue.value <= 0) {
        // Sin default (R7 en add-buyer) es una respuesta exitosa: nada que reportar, pero
        // limpia un estado previo (de un comprador anterior) que ya no corresponde.
        this.purchaseMethodStatus = null;
        return;
      }

      if (this.order?.purchaseMethod !== defaultValue.value) {
        this.store.dispatch(setOrderToGenerate({
          order: { ...this.order, purchaseMethod: defaultValue.value },
        }));
      }
    });
  }

  /* order.price.observations.buyer -- the field validatePurchaseMethod and VALCOMO
  actually key on -- stays 0 through the whole creation flow, because creation has no
  buyer-selection field of its own (only the OnlySell/NotSell restriction, a different
  concept). OrderValidator.setMainFeaturesOfOrders (shared/order.ts) already infers a
  single implied buyer from OnlySell, but only once, right before sending to IBM
  (DialogOrderCreate.sendOrderToIBM) -- too late for the interactive validation the
  operator sees on screen to ever have run. Mirroring that same inference live means a
  purchase method chosen while OnlySell narrows to exactly one buyer gets validated
  against that buyer before the confirm action is ever enabled, instead of reaching IBM
  unvalidated through the direct Commodities/operator path. */
  private resolveImpliedBuyerFromOnlySell(order: Order): number {
    // onlySell/notSell are typed any ("number or number[]", order.interface.ts) because
    // some paths still write a scalar; coerce the same way resolvePurchaseMethodForCreation
    // already does for onlySell just above.
    const toArray = (value: any): number[] => Array.isArray(value) ? value : (value ? [value] : []);

    if (toArray(order.buyer?.notSell).includes(COMMODITIES_CODE)) {
      return -1;
    }

    const onlySell = toArray(order.buyer?.onlySell);
    const impliedBuyer = onlySell.length === 1 ? Number(onlySell[0]) : -1;

    if (impliedBuyer <= 0) {
      return -1;
    }

    if (order.price?.observations?.buyer !== impliedBuyer) {
      this.store.dispatch(setOrderToGenerate({
        order: {
          ...order,
          price: { ...order.price, observations: { ...order.price.observations, buyer: impliedBuyer } },
        },
        tag: orderTags.price,
        subTag: priceTags.observations,
        thirdTag: priceTags.buyer,
      }));
    }

    /* Returned even though the dispatch above may be a no-op (buyer already matches):
    resolvePurchaseMethodForCreation needs this same resolved value (not the raw
    onlySell[0] it separately computes for visibility/editability) to key COMODEF (R1/R4). */
    return impliedBuyer;
  }

  private isEqualsPurchaseMethod(state: PurchaseMethodState | null, lastState: PurchaseMethodState | null): boolean {
    if (state && lastState) {
      return state.buyerCode == lastState.buyerCode && state.purchaseMethod == lastState.purchaseMethod;
    }
    return false;
  }
}
